import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M11.982 6a4.01 4.01 0 0 0-3.976 3.412.51.51 0 0 0 .499.588h1.02c.23 0 .44-.155.484-.381A2.01 2.01 0 0 1 13.99 10c0 .82-.581 1.625-1.225 1.84-1.168.389-1.79 1.441-1.79 2.16v.5c0 .276.226.5.504.5h1.004a.5.5 0 0 0 .502-.5v-.264c0-.215.139-.395.33-.465v-.001C13.866 13.625 16 12.469 16 10c0-2.21-1.8-4-4.02-4M11.981 16a1 1 0 1 0 .001 2 1 1 0 0 0 0-2" }),
      _createElementVNode("path", { d: "M12 21c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9m0-19C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2" })
    ], -1)
  ]))]))
}
export default { render: render }